import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { ThumbnailSimpleText } from '../../common/SimpleText';
import Viewer from '../../FileViewers/ThumbnailViewer';

const Tell = props =>
    <div
        className={`board-layout layout-tell layout-${props.slide.layout} thumbnail-tell`}
        style={{ background: props.slide.backgroundColor.toCSS() }}
    >
        <div className='ib-file-container'>
            { props.slide.media && <Viewer file={props.slide.media} /> }
        </div>
        {
            (!props.slide.media && !props.slide.text.text) &&
                <div className='ib-slide-empty'>{ gettext('Board is empty') }</div>
        }
        <ThumbnailSimpleText board={props.slide} text={props.slide.text} />
    </div>;

Tell.propTypes = {
    slide: PropTypes.object.isRequired
};

export default observer(Tell);
